import { Box, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Typography, palette } from "@powerdiary/components-library/lib";
import { DateTime } from "luxon";
import styles from "./CalendarMonthPicker.module.css";

interface CalendarMonthPickerProps {
    currentMonth: DateTime;
    onPreviousMonth: () => void;
    onNextMonth: () => void;
}

export default function CalendarMonthPicker({
    currentMonth,
    onPreviousMonth,
    onNextMonth,
}: Readonly<CalendarMonthPickerProps>) {
    const now = DateTime.now();
    const isPreviousDisabled = currentMonth.startOf("month") <= now.startOf("month");

    return (
        <Box
            sx={{ border: `1px solid ${palette.neutral["300"]}`, borderRadius: "4px" }}
            className={styles.wrapper}
            data-test-id="section_calendar_month_picker"
        >
            <Box sx={{ borderRight: `1px solid ${palette.neutral["300"]}`, pr: 1 }}>
                <IconButton
                    data-test-id="button_previous_month"
                    onClick={onPreviousMonth}
                    size="small"
                    disabled={isPreviousDisabled}
                    sx={{
                        opacity: isPreviousDisabled ? 0.3 : 1,
                        cursor: isPreviousDisabled ? "not-allowed" : "pointer",
                    }}
                >
                    <ChevronLeft size={20} strokeWidth={2} aria-hidden />
                </IconButton>
            </Box>

            <Typography variant="paragraphLargeSemiBold" className={styles.monthYear} data-test-id="text_current_month">
                {currentMonth.toFormat("MMMM yyyy")}
            </Typography>
            <Box sx={{ borderLeft: `1px solid ${palette.neutral["300"]}`, pl: 1 }}>
                <IconButton onClick={onNextMonth} size="small" data-test-id="button_next_month">
                    <ChevronRight size={20} strokeWidth={2} aria-hidden />
                </IconButton>
            </Box>
        </Box>
    );
}
